import { render, staticRenderFns } from "./UserWiseCourseEnrollment.vue?vue&type=template&id=4bdfd4e0&scoped=true&"
import script from "./UserWiseCourseEnrollment.vue?vue&type=script&lang=js&"
export * from "./UserWiseCourseEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./UserWiseCourseEnrollment.vue?vue&type=style&index=0&id=4bdfd4e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdfd4e0",
  null
  
)

export default component.exports